import debug from 'debug';
import { BaseActions } from '@/models/Common/Actions/BaseActions';
import IntegratedAutocompleteRequestBuilder from '@/models/IntegratedAutocomplete/IntegratedAutocompleteRequestBuilder';
import {
  IIntegratedAutocompleteSuggestionRequestParams,
  IIntegratedAutocompleteSuggestionPayload,
  IIntegratedAutocompleteSuggestionGlobalRequestParams,
  IIntegratedAutocompleteStationSuggestionRequestParams,
  IIntegratedAutocompleteStationSuggestionPayload,
} from '@/models/IntegratedAutocomplete/interfaces';
import { ResponseEither } from '@/models/Common/ResponseEither';
import { execAction } from '@/models/Common/Actions/handler';

const log = debug('sunny:IntegratedAutocompleteActions');

export default class IntegratedAutocompleteActions extends BaseActions<IntegratedAutocompleteRequestBuilder> {
  domesticAccommodationSuggestions(
    params: IIntegratedAutocompleteSuggestionRequestParams,
  ): Promise<ResponseEither<IIntegratedAutocompleteSuggestionPayload>> {
    log('integrated suggestions domestic accommodation');
    return execAction(
      'integrated suggestions domestic accommodation',
      this.requestBuilder.createGetDomesticSuggestionsAccommodationList(params),
    );
  }

  domesticLeisureSuggestions(
    params: IIntegratedAutocompleteSuggestionRequestParams,
  ): Promise<ResponseEither<IIntegratedAutocompleteSuggestionPayload>> {
    log('integrated suggestions domestic leisure');
    return execAction(
      'integrated suggestions domestic leisure',
      this.requestBuilder.createGetDomesticSuggestionsLeisureList(params),
    );
  }

  globalLocationSuggestions(
    params: IIntegratedAutocompleteSuggestionGlobalRequestParams,
  ): Promise<ResponseEither<IIntegratedAutocompleteSuggestionPayload>> {
    log('integrated suggestions global location');
    return execAction(
      'integrated suggestions global location',
      this.requestBuilder.createPostGlobalSuggestionsLocationList(params),
    );
  }

  trainStationSuggestions (
    params: IIntegratedAutocompleteStationSuggestionRequestParams,
  ): Promise<ResponseEither<IIntegratedAutocompleteStationSuggestionPayload>> {
    log('integrated suggestions train station');
    return execAction(
      'integrated suggestions train station',
      this.requestBuilder.createGetTrainStationSuggestionsList(params),
    );
  }
}
